/**
 * Speed's mark: one bolt for Fast, two for Ultrafast, none for Standard.
 *
 * @module components/chat/ModelEffortSpeedIcon
 */
import type { AgentServiceTier } from "@repo/shared/agentModels";
import { ZapIcon } from "lucide-react";

import { cn } from "~/lib/utils";
import { UltrafastZapIcon } from "./TraitsPicker";

export function ModelEffortSpeedIcon({
  tier,
  fine = false,
  className,
}: {
  readonly tier: AgentServiceTier;
  /** The fine composer finish: Fast's bolt at 14px and a 1.75 stroke. */
  readonly fine?: boolean;
  readonly className?: string;
}) {
  if (tier === "ultrafast") {
    // 28.5-unit box around the same 24-unit bolt: 14.25px draws each bolt at Fast's 12px scale.
    return <UltrafastZapIcon aria-hidden="true" className={cn("size-[14.25px] shrink-0", className)} />;
  }
  if (tier === "fast") {
    return <ZapIcon aria-hidden="true" className={cn("shrink-0 fill-current", fine ? "size-3.5 stroke-[1.75]" : "size-3", className)} />;
  }
  return null;
}
